import { countdownStyle } from "../style"

export interface TimeProps {
    value: number
}

export function Time(props: TimeProps) {
    return <span className={countdownStyle.timer}>{props.value}</span>
}
